export const filterFAQs = (faqs) =>
  faqs
    .map((faq) => ({
      question: faq.question.trim(),
      answer: faq.answer.trim()
    }))
    .filter((faq) => faq.question && faq.answer)
